import React, { Component } from "react";
import { auth } from "../../utils/auth";
import { apiUrl } from "../../utils/apiUrl";
import { toast, formatCurrency, getLink } from "../../utils/helpers";
import Loader from "../general/Loader";
import Modal from "../general/Modal";

class Edit extends Component {
    state = {
        errors: {},
        showDelete: false,
    };
    editUser = async (event) => {
        event.preventDefault();

        if (!auth.can("editar-inventario")) return;

        const token = auth.getToken();
        const data = new FormData(event.target);

        const res = await fetch(apiUrl(`items/${this.props.item.id}`), {
            method: "post",
            body: data,
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        const response = await res.json();

        if (response.success) {
            this.props.history.push(getLink("/inventario"));
        }

        if (response.code === 422) {
            this.setState({ errors: response.data.message });
        }
    };
    toggleDeleteModal = () => {
        this.setState({
            showDelete: !this.state.showDelete,
        });
    };
    deleteItem = async (item) => {
        const token = auth.getToken();

        const url = `items/${item}`;

        const res = await fetch(apiUrl(url), {
            method: "delete",
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        const response = await res.json();

        if (response.success) {
            this.props.history.push(getLink("/inventario"));
            toast("Item borrado.");
            return;
        } else {
            toast(response.data, "error");
        }
    };
    render() {
        const { errors } = this.state;
        const { item, grupos, almacenes } = this.props;

        const notEditable = !auth.can("editar-inventario");

        if (item === {}) {
            return <Loader />;
        }

        return (
            <div>
                <form
                    method='post'
                    onSubmit={this.editUser}
                    className='col-md-10'>
                    <input type='hidden' name='_method' value='patch' />
                    <input type='hidden' name='item_id' value={item.id} />
                    <div>
                        <div className='row form-group'>
                            <div className='col col-md-5'>
                                <label className='label form-control-label'>
                                    Nombre:
                                </label>
                            </div>
                            <div className='col col-md-7'>
                                <input
                                    type='text'
                                    className='text-input form-control'
                                    id='nombre'
                                    name='nombre'
                                    disabled={notEditable}
                                    defaultValue={item.nombre}
                                />
                                {errors.nombre && (
                                    <small className='help-blockParams form-Text'>
                                        {errors.nombre[0]}
                                    </small>
                                )}
                            </div>
                        </div>
                        <div className='row form-group'>
                            <div className='col col-md-5'>
                                <label className='label form-control-label'>
                                    Referencia:
                                </label>
                            </div>
                            <div className='col col-md-7'>
                                <input
                                    type='text'
                                    className='text-input form-control'
                                    id='referencia'
                                    name='referencia'
                                    disabled={notEditable}
                                    defaultValue={item.referencia}
                                />
                                {errors.referencia && (
                                    <small className='help-blockParams form-Text'>
                                        {errors.referencia[0]}
                                    </small>
                                )}
                            </div>
                        </div>
                        <div className='row form-group'>
                            <div className='col col-md-5'>
                                <label className='label form-control-label'>
                                    Estado:
                                </label>
                            </div>
                            <div className='col col-md-7'>
                                {item.estado && (
                                    <select
                                        type='text'
                                        className='text-input form-control'
                                        id='estado'
                                        name='estado'
                                        disabled={notEditable}
                                        defaultValue={item.estado}>
                                        <option value='nuevo'>Nuevo</option>
                                        <option value='usado'>Usado</option>
                                    </select>
                                )}
                                {errors.estado && (
                                    <small className='help-blockParams form-Text'>
                                        {errors.estado[0]}
                                    </small>
                                )}
                            </div>
                        </div>
                        <div className='row form-group'>
                            <div className='col col-md-5'>
                                <label className='label form-control-label'>
                                    Unidad:
                                </label>
                            </div>
                            <div className='col col-md-7'>
                                {item.unidad && (
                                    <select
                                        type='text'
                                        className='text-input form-control'
                                        id='unidad'
                                        name='unidad'
                                        disabled={notEditable}
                                        defaultValue={item.unidad}>
                                        <option value='UND'>UND</option>
                                        <option value='JUEGO'>JUEGO</option>
                                        <option value='PIES'>PIES</option>
                                        <option value='PULG'>PULG</option>
                                        <option value='MTS'>MTS</option>
                                        <option value='CM'>CM</option>
                                        <option value='GLS'>GLS</option>
                                        <option value='LATA'>LATA</option>
                                        <option value='CUBETA'>CUBETA</option>
                                        <option value='CUARTOS'>CUARTOS</option>
                                        <option value='LITROS'>LITROS</option>
                                        <option value='LBS'>LBS</option>
                                        <option value='KGS'>KGS</option>
                                    </select>
                                )}
                                {errors.unidad && (
                                    <small className='help-blockParams form-Text'>
                                        {errors.unidad[0]}
                                    </small>
                                )}
                            </div>
                        </div>
                        {grupos.length > 0 && (
                            <div className='row form-group'>
                                <div className='col col-md-5'>
                                    <label className='label form-control-label'>
                                        Grupo:
                                    </label>
                                </div>
                                <div className='col col-md-7'>
                                    <select
                                        className='text-input form-control'
                                        id='grupo_id'
                                        name='grupo_id'
                                        disabled={notEditable}
                                        defaultValue={
                                            item.grupo ? item.grupo.id : false
                                        }>
                                        <option value=''>
                                            - Seleccionar -
                                        </option>
                                        {grupos.map((grupo) => (
                                            <option
                                                key={grupo.id}
                                                value={grupo.id}>
                                                {grupo.nombre}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.grupo_id && (
                                        <small className='help-blockParams form-Text'>
                                            {errors.grupo_id[0]}
                                        </small>
                                    )}
                                </div>
                            </div>
                        )}
                        {almacenes.length > 0 && item.almacen && (
                            <div className='row form-group'>
                                <div className='col col-md-5'>
                                    <label className='label form-control-label'>
                                        Almacen:
                                    </label>
                                </div>
                                <div className='col col-md-7'>
                                    <select
                                        className='text-input form-control'
                                        id='almacen_id'
                                        name='almacen_id'
                                        disabled={notEditable}
                                        defaultValue={
                                            item.almacen
                                                ? item.almacen.id
                                                : false
                                        }>
                                        <option value=''>
                                            - Seleccionar -
                                        </option>
                                        {almacenes.map((almacen) => (
                                            <option
                                                key={almacen.id}
                                                value={almacen.id}>
                                                {almacen.nombre}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.almacen_id && (
                                        <small className='help-blockParams form-Text'>
                                            {errors.almacen_id[0]}
                                        </small>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='row form-group'>
                        <div className='col col-md-5'>
                            <label className='label form-control-label'>
                                Descripción:
                            </label>
                        </div>
                        <div className='col col-md-7'>
                            <textarea
                                className='text-input form-control'
                                id='descripcion'
                                name='descripcion'
                                rows='4'
                                disabled={notEditable}
                                defaultValue={item.descripcion}
                            />
                            {errors.descripcion && (
                                <small className='help-blockParams form-Text'>
                                    {errors.descripcion[0]}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className='row form-group'>
                        <div className='col col-md-5'>
                            <label className='label form-control-label'>
                                Costo/Und:
                            </label>
                        </div>
                        <div className='col col-md-7'>
                            {formatCurrency(item.costo)}
                        </div>
                    </div>
                    <div className='row form-group'>
                        <div className='col col-md-5'>
                            <label className='label form-control-label'>
                                Cantidad Disponible:
                            </label>
                        </div>
                        <div className='col col-md-7'>
                            {item.inventariable ? (
                                item.cantidad
                            ) : (
                                <span>&infin;</span>
                            )}
                        </div>
                    </div>

                    <div className='page-footer text-right'>
                        {!notEditable && (
                            <button
                                type='button'
                                className='btn float-left'
                                onClick={this.toggleDeleteModal}>
                                <i className='fas fa-trash-alt'></i>
                            </button>
                        )}
                        <button
                            type='button'
                            onClick={() =>
                                this.props.history.push(getLink("/inventario"))
                            }
                            className='btn btn-plain'>
                            Cancelar
                        </button>
                        {!notEditable && (
                            <button type='submit' className='btn btn-primary'>
                                Guardar
                            </button>
                        )}
                    </div>
                </form>
                <Modal
                    title='Borrar Item'
                    show={this.state.showDelete}
                    callback={() => this.deleteItem(item.id)}
                    acceptText='Borrar'
                    toggle={this.toggleDeleteModal}>
                    ¿Estás seguro de que deseas borrar este item?
                </Modal>
            </div>
        );
    }
}

export default Edit;
